var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFB170",
    fillRule: "evenodd",
    d: "M6 7c1.306 0 2.418.835 2.83 2H21a1 1 0 1 1 0 2H8.829a3.001 3.001 0 0 1-5.658 0H1a1 1 0 1 1 0-2h2.17A3.001 3.001 0 0 1 6 7Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm10-9c1.306 0 2.418.835 2.83 2H21a1 1 0 1 1 0 2h-2.171a3.001 3.001 0 0 1-5.658 0H1a1 1 0 1 1 0-2h12.17A3.001 3.001 0 0 1 16 0Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm0 12c1.306 0 2.418.835 2.83 2H21a1 1 0 1 1 0 2h-2.171a3.001 3.001 0 0 1-5.658 0H1a1 1 0 1 1 0-2h12.17A3.001 3.001 0 0 1 16 14Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/iconFilter.12fb866bc7e1363adbe2f481399c7944.svg";
export { ForwardRef as ReactComponent };